module.exports = __webpack_public_path__ + "img/d.71897ce9.jpg";